import StarsIcon from 'components/header/stars-icon';
import styles from 'styles/HeaderSection.module.scss';
import { usePageInfo } from 'context/PageInfoContext';
import { useTranslations } from 'next-intl';

export const SwiperQualificationStarts = () => {
    const t = useTranslations('swiper.qualification-stars');
    const { pageInfo } = usePageInfo();
    const totalRating = parseInt(pageInfo.page_context.raiting_global[1].value);
    const handleClick = () => {
        const scrollToElement = () => {
            const elm = document.getElementById('almost-five');
            if (elm?.scrollIntoView) {
                elm.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        };

        scrollToElement();
    };

    return (
        <div
            className={styles.qualificationStarsContainer}
            itemScope
            itemType="http://schema.org/Product"
        >
            <meta itemProp="brand" content={t('item-prop-brand')} />
            <meta itemProp="name" content={t('item-prop-name')} />
            <div className={styles.startsContainer}>
                <div onClick={handleClick}>
                    <StarsIcon width={150} height={25} />
                </div>
            </div>
            <div
                itemProp="aggregateRating"
                itemScope
                itemType="http://schema.org/AggregateRating"
            >
                <meta itemProp="worstRating" content={t('worst-rating')} />
                <meta itemProp="bestRating" content={t('best-rating')} />
                <p className={styles.bottomLegend}>
                    <strong itemProp="ratingValue">{4.8} </strong>
                    {t('of')}
                    <strong> 5</strong>
                    {' '}
                    {t('in')}{' '}
                    <strong itemProp="ratingCount">{totalRating} </strong>
                    {t('qualifications')}
                </p>
            </div>
            <div className="column"></div>
        </div>
    );
};
